import React from 'react'
import { connect } from 'react-redux'
import agent from '../agent'
import numberHelper from '../util/numberFormatter'
import Loading from './widgets/Loading'
import Header from './widgets/Header'
import QRCode from './widgets/QRCode'
import CartList from './widgets/CartItemList'
import TransactionList from './widgets/TransactionList'
import {
  CART_LOADED,
  RESET_CART
} from '../constants/actionTypes'
import { BASE_COIN_SYMBOL } from '../constants/config'

const isNumber = (v) => {
  return typeof v === 'number' && isFinite(v)
}
const mapStateToProps = state => ({
  ...state.cart,
  baseAccount: state.common.baseAccount,
  recentTransactions: state.common.recentTransactions,
  newTransactionAdded: state.common.newTransactionAdded
})

const mapDispatchToProps = dispatch => ({
  onLoad: (payload) => {
    dispatch({ type: CART_LOADED, payload })
  },
  onResetCart: () =>
    dispatch({ type: RESET_CART })
})

class Cart extends React.Component {
  constructor() {
    super()
    this.state = {
      cartItems: [],
      notes: '',
      cart_amount: 0,
      additional_amount: 0,
      total_amount: 0
    }
    this.updateState = field => ev => {
      const state = this.state;
      const newState = Object.assign({}, state, { [field]: ev.target.value });
      this.setState(newState);
    }
    this.keyPress = (e) => {
      // ev.preventDefault()
      if (e.charCode !== 13) return
    }
    this.resetCart = () => ev => {
      ev.preventDefault();
      Object.assign(this.state, {
        notes: '',
        additional_amount: 0,
        discount_value: '',
        tax_value: ''
      })
      this.props.onResetCart();
    }
  }

  componentWillMount() {
    if (this.props.cart_items) {
      Object.assign(this.state, {
        cartItems: this.props.cart_items,
        cart_amount: this.props.cart_amount,
      })
    }
    let payload = null
    if (this.props.baseAccount) {
      payload = agent.Common.getTransactions(this.props.baseAccount.external)
    }

    this.props.onLoad(payload)
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.cart_items) {
      Object.assign(this.state, {
        cartItems: nextProps.cart_items,
        cart_amount: nextProps.cart_amount,
      })
    }
  }
  componentWillUnmount() {
  }
  render() {
    const cartItems = this.state.cartItems
    const additional_amount = this.state.additional_amount
    const notes = this.state.notes
    const cart_amount = this.state.cart_amount || 0
    const discount_value = this.state.discount_value
    const tax_value = this.state.tax_value
    const discount_percentage = (discount_value || 0) / 100
    const tax_percentage = (tax_value || 0) / 100

    const total_amount = numberHelper.Formatter.roundUp((cart_amount * 1 + (additional_amount || 0) * 1) * (1 - discount_percentage) * (1 + tax_percentage), 2)
    const payment = {
      address: this.props.baseAccount.external,
      symbol: this.props.baseAccount.symbol,
      notes: this.state.notes,
      amount: total_amount,
    }
    const jsonStr = JSON.stringify({ payment })


    return (
      <div>
        <Header />
        <div id="main"><div id="main-wrap">
          <div id="content">
            <h2>Cart <i id='resetCartButton' className={' icon ion-md-refresh-circle'} onClick={this.resetCart()} title={'Reset Cart'}></i>
            </h2>
            <CartList data={cartItems} />
            <div className="FormItem">
              <label>Reference</label>
              <input type="text" value={notes} onChange={this.updateState('notes')} />
            </div>
            <div className="FormItem">
              <label>Cart Amount</label>
              <span className="ReferenceInput">{cart_amount}</span>
            </div>
            <div className="FormItem">
              <label>Additional Amount</label>
              <input type="text" value={additional_amount} onChange={this.updateState('additional_amount')} onKeyPress={(e) => this.keyPress(e)} />
            </div>
            <div className="FormItem">
              <label>Discount percentage</label>
              <input type="text" value={discount_value} onChange={this.updateState('discount_value')} />
            </div>
            <div className="FormItem">
              <label>Tax percentage</label>
              <input type="text" value={tax_value} onChange={this.updateState('tax_value')} />
            </div>
            <div className="FormItem">
              <label>Total Amount</label>
              <span className="ReferenceInput">{total_amount}</span>
            </div>
            <h2>Payment Code</h2>
            <div id="PaymentQR">
              {/* render QR which is readable by XIF App, {address}, but add additional elements, amount: and note: (we will update the XIF app to support note and amount) */}
              <QRCode value={jsonStr} />
            </div>

            <h2>Transactions</h2>
            <TransactionList data={{ recentTransactions: this.props.recentTransactions, newTransactionAdded: this.props.newTransactionAdded }} />
          </div>
        </div></div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Cart)
